module.exports = __webpack_public_path__ + "img/logo-plta.9a91a3fc.png";